import { defineStore } from 'pinia'
import { actions, getters, state } from './ext/items.js'
import axios from 'axios'


export const useFundraiserCategoryStore = defineStore('fundraiserCategory', {
  id: 'fundraiserCategory',
  state: () => ({
    items: [],
    api: '/api/v1/fundraiser-categories'
  }),
  getters: {
    ...getters
  },
  actions: {
    ...actions
  }
})
